import React, { memo } from 'react';
import cn from 'classnames';
import Content from './Content';
import Navigation from './Navigation';
import { IContent, INavigation } from './types';
import styles from './stickyFooter.module.scss';

interface IProps {
  className?: string,
  contentClassName?: string,
  navigationClassName?: string,
  logoClassName?: string,
  linksContainerClassName?: string,
  config: {
    content: IContent[],
    navigation: INavigation[],
  },
}

const StickyFooter = (props: IProps) => (
  // @ts-ignore
  <div className={ cn(styles.container, { [props.className]: !!props.className }) }>
    <Content
      dataTest="footerContent"
      config={ props.config.content }
      className={ props.contentClassName }
      logoClassName={ props.logoClassName }
      linksContainerClassName={ props.linksContainerClassName }
    />
    <Navigation
      links={ props.config.navigation }
      className={ props.navigationClassName }
      logoClassName={ props.logoClassName }
    />
  </div>
);

export default memo(StickyFooter);
